export const FEATURE_FLAG_STANDALONE_PROVISIONING = 'standalone-provisioning'
